export const messages = {
  title: {
    id: "video-player.title",
    defaultMessage: "Video Player",
  },
};
